import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import {checkAppNotAvailable, checkAuthentication, checkNoAuthentication} from './guards/routeguards';

Vue.use(Router);

let router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            meta: {
                title: 'Startseite'
            }
        },
        {
            path: '/app-not-available',
            name: 'app-not-available',
            component: () => import(/* webpackChunkName: "app-not-available" */ './views/AppNotAvailable.vue'),
            meta: {
                title: 'Anwendung nicht verfügbar'
            },
            beforeEnter: checkAppNotAvailable
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: () => import(/* webpackChunkName: "dashboard" */ './views/Dashboard.vue'),
            meta: {
                title: 'Übersicht'
            },
            beforeEnter: checkAuthentication
        },
        {
            path: '/impressum',
            name: 'impressum',
            component: () => import(/* webpackChunkName: "impressum" */ './views/Impressum.vue'),
            meta: {
                title: 'Impressum'
            }
        },
        {
            path: '/login',
            name: 'login',
            component: () => import(/* webpackChunkName: "login" */ './views/Login.vue'),
            meta: {
                title: 'Login'
            },
            beforeEnter: checkNoAuthentication
        },
        {
            path: '/confirm',
            name: 'confirm',
            component: () => import(/* webpackChunkName: "confirm" */ './views/Confirm.vue'),
            meta: {
                title: 'Bestätigung'
            },
            beforeEnter: checkNoAuthentication
        },
        {
            path: '/forgot-password',
            name: 'forgot-password',
            component: () => import(/* webpackChunkName: "forgot-password" */ './views/ForgotPassword.vue'),
            meta: {
                title: 'Passwort vergessen'
            },
            beforeEnter: checkNoAuthentication
        },
        {
            path: '/reset-password',
            name: 'reset-password',
            component: () => import(/* webpackChunkName: "reset-password" */ './views/ResetPassword.vue'),
            meta: {
                title: 'Passwort vergeben'
            },
            beforeEnter: checkNoAuthentication
        },
        {
            path: '/administration',
            name: 'administration',
            component: () => import(/* webpackChunkName: "administration" */ './views/administration/Index.vue'),
            meta: {
                title: 'Administration'
            },
            beforeEnter: checkAuthentication,
            children: [
                {
                    path: 'users',
                    name: 'users',
                    component: () => import(/* webpackChunkName: "users" */ './views/Users.vue'),
                    meta: {
                        title: 'Benutzer'
                    }
                },
                {
                    path: 'languages',
                    name: 'languages',
                    component: () => import(/* webpackChunkName: "languages" */ './views/administration/Languages.vue'),
                    meta: {
                        title: 'Sprachen'
                    }
                },
                {
                    path: 'countries',
                    name: 'countries',
                    component: () => import(/* webpackChunkName: "countries" */ './views/administration/Countries.vue'),
                    meta: {
                        title: 'Länder'
                    }
                },
                {
                    path: 'rsvs',
                    name: 'rsvs',
                    component: () => import(/* webpackChunkName: "rsvs" */ './views/administration/RSVs.vue'),
                    meta: {
                        title: 'Rechtsschutzversicherungen'
                    }
                },
                {
                    path: 'reminder-mail-jobs',
                    name: 'reminder-mail-jobs',
                    component: () => import(/* webpackChunkName: "reminder-mail-jobs" */ './views/administration/ReminderMailJobs.vue'),
                    meta: {
                        title: 'Erinnerungsmails'
                    }
                },
                // {
                //     path: 'check-jobs',
                //     name: 'check-jobs',
                //     component: () => import(/* webpackChunkName: "check-jobs" */ './views/administration/CheckJobs.vue'),
                //     meta: {
                //         title: 'Checkjobs'
                //     }
                // },
                {
                    path: 'event-log',
                    name: 'event-log',
                    component: () => import(/* webpackChunkName: "event-log" */ './views/administration/Events.vue'),
                    meta: {
                        title: 'Eventlog'
                    }
                },
                {
                    path: 'maintenance-mode',
                    name: 'maintenance-mode',
                    component: () => import(/* webpackChunkName: "maintenance-mode" */ './views/administration/MaintenanceMode.vue'),
                    meta: {
                        title: 'Wartung'
                    }
                },
            ]
        },
        // {
        //     path: '/kuendigung',
        //     name: 'kuendigung',
        //     component: () => import(/* webpackChunkName: "kuendigung" */ './views/kuendigung/Index.vue'),
        //     meta: {
        //         title: 'Kündigung'
        //     },
        //     beforeEnter: checkAuthentication,
        //     children: [
        //         {
        //             path: 'overview',
        //             name: 'kuendigungsOverview',
        //             component: () => import(/* webpackChunkName: "users" */ './views/kuendigung/Overview.vue'),
        //             meta: {
        //                 title: 'Kündigungsfälle - Übersicht'
        //             }
        //         },
        //         {
        //             path: 'create-case',
        //             name: 'kuendigungCreateCase',
        //             component: () => import(/* webpackChunkName: "users" */ './views/kuendigung/CreateCase.vue'),
        //             meta: {
        //                 title: 'Kündigungsfälle - Neuer Fall'
        //             }
        //         },
        //         {
        //             path: 'edit-case/:case_id',
        //             name: 'kuendigungEditCase',
        //             component: () => import(/* webpackChunkName: "users" */ './views/kuendigung/CreateCase.vue'),
        //             props: true,
        //             meta: {
        //                 title: 'Kündigungsfälle - Fall editieren'
        //             }
        //         }
        //     ]
        // },
        {
            path: '/flights',
            name: 'flights',
            component: () => import(/*webpackChunkName: "flights" */ './views/flights/Index.vue'),
            meta: {
                title: 'Flüge'
            },
            beforeEnter: checkAuthentication,
            children: [
                {
                    path: 'overview',
                    name: 'flights-overview',
                    component: () => import(/* webpackChunkName: "flights-overview" */ './views/flights/Overview.vue'),
                    meta: {
                        title: 'Flugverspätung - Übersicht'
                    }
                },
                {
                    path: 'airlines',
                    name: 'airlines',
                    component: () => import(/* webpackChunkName: "airlines" */ './views/flights/Airlines.vue'),
                    meta: {
                        title: 'Fluglinien'
                    }
                },
                {
                    path: 'general-travel-overview',
                    name: 'general-travel-overview',
                    component: () => import(/* webpackChunkName: "general-travel-overview" */ './views/flights/GeneralTravelOverview.vue'),
                    meta: {
                        title: 'Allgemeines Reiserecht - Übersicht'
                    }
                },
            ]
        },
        {
            path: '/tools',
            name: 'tools',
            component: () => import(/* webpackChunkName: "tools" */ './views/tools/Index.vue'),
            meta: {
                title: 'Toolbox'
            },
            beforeEnter: checkAuthentication,
            children: [
                {
                    path: 'file-requester',
                    name: 'file-requester',
                    component: () => import(/* webpackChunkName: "file-requester" */ './views/tools/FileRequester.vue'),
                    meta: {
                        title: 'Dokument/-e anfordern'
                    }
                },
                {
                    path: 'file-access-granter',
                    name: 'file-access-granter',
                    component: () => import(/* webpackChunkName: "file-access-granter" */ './views/tools/FileAccessGranter.vue'),
                    meta: {
                        title: 'Dokument/-e freigeben'
                    }
                },
                {
                    path: 'rating-invitation',
                    name: 'rating-invitation',
                    component: () => import(/* webpackChunkName: "rating-invitation" */ './views/tools/RatingInvitation.vue'),
                    meta: {
                        title: 'Bewertungseinladung'
                    }
                }
            ]
        },
        {
            path: '/transport',
            name: 'transport',
            component: () => import(/* webpackChunkName: "transport" */ './views/transport/Index.vue'),
            meta: {
                title: 'Verkehr'
            },
            beforeEnter: checkAuthentication,
            children: [
                {
                    path: 'overview',
                    name: 'transport-overview',
                    component: () => import(/* webpackChunkName: "transport-overview" */ './views/transport/Overview.vue'),
                    meta: {
                        title: 'Verkehrsunfälle'
                    }
                },
                {
                    path: 'insurances',
                    name: 'transport-insurances',
                    component: () => import(/* webpackChunkName: "transport-insurances" */ './views/transport/Insurances.vue'),
                    meta: {
                        title: 'KFZ-Versicherungen'
                    }
                }
            ]
        },
        {
            path: '/emissions',
            name: 'emissions',
            component: () => import(/* webpackChunkName: "emissions" */ './views/emissions/Index.vue'),
            meta: {
                title: 'Abgasskandal'
            },
            beforeEnter: checkAuthentication,
            children: [
                {
                    path: 'overview',
                    name: 'emissions-overview',
                    component: () => import(/* webpackChunkName: "emissions-overview" */ './views/emissions/Overview.vue'),
                    meta: {
                        title: 'Abgasskandal - Übersicht'
                    }
                },
                {
                    path: 'kba-requests',
                    name: 'emissions-kba-requests',
                    component: () => import(/* webpackChunkName: "emissions-kba-requests" */ './views/emissions/KBARequests.vue'),
                    meta: {
                        title: 'Abgasskandal - KBA-Anfragen'
                    }
                },
                {
                    path: 'emission-compensation-overview',
                    name: 'emission-compensation-overview',
                    component: () => import(/* webpackChunkName: "emission-compensation-overview" */ './views/emissions/EmissionCompensationOverview.vue'),
                    meta: {
                        title: 'Abgasskandal - Übersicht Widerrufe'
                    }
                },
                {
                    path: 'vehicle-manufacturers',
                    name: 'emission-vehicle-manufacturers',
                    component: () => import(/* webpackChunkName: "emission-vehicle-manufacturers" */ './views/emissions/VehicleManufacturers.vue'),
                    meta: {
                        title: 'KFZ-Hersteller'
                    }
                },
                // {
                //     path: 'emission-victim-checks',
                //     name: 'emission-victim-checks',
                //     component: () => import(/* webpackChunkName: "emission-victim-checks" */ './views/emissions/EmissionVictimChecks.vue'),
                //     meta: {
                //         title: 'Abgasskandal - Betroffenheitsprüfungen'
                //     }
                // },
            ]
        },
        {
            path: '/bank-fees',
            name: 'bank-fees',
            component: () => import(/*webpackChunkName: "bank-fees" */ './views/bankFees/Index.vue'),
            meta: {
                title: 'Bankgebühren'
            },
            beforeEnter: checkAuthentication,
            children: [
                {
                    path: 'overview',
                    name: 'bank-fees-overview',
                    component: () => import(/* webpackChunkName: "bank-fees-overview" */ './views/bankFees/Overview.vue'),
                    meta: {
                        title: 'Bankgebühren - Übersicht'
                    }
                },
            ]
        },
        {
            path: '/gym-fees',
            name: 'gym-fees',
            component: () => import(/*webpackChunkName: "gym-fees" */ './views/gymFees/Index.vue'),
            meta: {
                title: 'Fitnessstudiogebühren'
            },
            beforeEnter: checkAuthentication,
            children: [
                {
                    path: 'overview',
                    name: 'gym-fees-overview',
                    component: () => import(/* webpackChunkName: "gym-fees-overview" */ './views/gymFees/Overview.vue'),
                    meta: {
                        title: 'Fitnessstudiogebühren - Übersicht'
                    }
                },
            ]
        },
        {
            path: '/vehicle-financing',
            name: 'vehicle-financing',
            component: () => import(/*webpackChunkName: "vehicle-financing" */ './views/vehicleFinancing/Index.vue'),
            meta: {
                title: 'KFZ-Widerruf'
            },
            beforeEnter: checkAuthentication,
            children: [
                {
                    path: 'overview',
                    name: 'vehicle-financing-overview',
                    component: () => import(/* webpackChunkName: "vehicle-financing-overview" */ './views/vehicleFinancing/Overview.vue'),
                    meta: {
                        title: 'KFZ-Widerruf - Übersicht'
                    }
                },
            ]
        },
        {
            path: '/phishing',
            name: 'phishing',
            component: () => import(/*webpackChunkName: "phishing" */ './views/phishing/Index.vue'),
            meta: {
                title: 'Phishing'
            },
            beforeEnter: checkAuthentication,
            children: [
                {
                    path: 'overview',
                    name: 'phishing-overview',
                    component: () => import(/* webpackChunkName: "phishing-overview" */ './views/phishing/Overview.vue'),
                    meta: {
                        title: 'Phishing - Übersicht'
                    }
                },
            ]
        },
        {
            path: '/cancellation',
            name: 'cancellation',
            component: () => import(/*webpackChunkName: "cancellation" */ './views/cancellation/Index.vue'),
            meta: {
                title: 'Kündigung'
            },
            beforeEnter: checkAuthentication,
            children: [
                {
                    path: 'overview',
                    name: 'cancellation-overview',
                    component: () => import(/* webpackChunkName: "cancellation-overview" */ './views/cancellation/Overview.vue'),
                    meta: {
                        title: 'Kündigung - Übersicht'
                    }
                },
                {
                    path: 'legacy-calculate-compensation-overview',
                    name: 'legacy-calculate-compensation-overview',
                    component: () => import(/* webpackChunkName: "legacy-calculate-compensation-overview" */ './views/legacy/calculateCompensation/Overview.vue'),
                    meta: {
                        title: 'Abfindungsrechner - Übersicht'
                    }
                },
                {
                    path: 'legacy-register-as-unemployed-overview',
                    name: 'legacy-register-as-unemployed-overview',
                    component: () => import(/* webpackChunkName: "legacy-register-as-unemployed-overview" */ './views/legacy/registerAsUnemployed/Overview.vue'),
                    meta: {
                        title: 'Arbeitslosmeldungen - Übersicht'
                    }
                },
            ]
        },
        {
            path: '/pwned',
            name: 'pwned',
            component: () => import(/*webpackChunkName: "pwned" */ './views/pwned/Index.vue'),
            meta: {
                title: 'Facebook Datenskandal'
            },
            beforeEnter: checkAuthentication,
            children: [
                {
                    path: 'overview',
                    name: 'pwned-overview',
                    component: () => import(/* webpackChunkName: "pwned-overview" */ './views/pwned/Overview.vue'),
                    meta: {
                        title: 'Facebook Datenskandal - Übersicht'
                    }
                },
            ]
        },
        {
            path: '/life-insurance',
            name: 'life-insurance',
            component: () => import(/*webpackChunkName: "life-insurance" */ './views/lifeInsurance/Index.vue'),
            meta: {
                title: 'Lebensversicherung Widerruf'
            },
            beforeEnter: checkAuthentication,
            children: [
                {
                    path: 'overview',
                    name: 'life-insurance-overview',
                    component: () => import(/* webpackChunkName: "life-insurance-overview" */ './views/lifeInsurance/Overview.vue'),
                    meta: {
                        title: 'Lebensversicherung Widerruf - Übersicht'
                    }
                },
            ]
        },
        {
            path: '/law-firm',
            name: 'law-firm',
            component: () => import(/* webpackChunkName: "law-firm" */ './views/law-firm/Index.vue'),
            meta: {
                title: 'Kanzlei'
            },
            beforeEnter: checkAuthentication,
            children: [
                {
                    path: 'events',
                    name: 'events',
                    component: () => import(/* webpackChunkName: "events" */ './views/law-firm/Events.vue'),
                    meta: {
                        title: 'Kanzleiveranstaltungen'
                    }
                },
                {
                    path: 'birthdays',
                    name: 'birthdays',
                    component: () => import(/* webpackChunkName: "birthdays" */ './views/law-firm/Birthdays.vue'),
                    meta: {
                        title: 'Geburtstagskalender'
                    }
                },
                {
                    path: 'feedback',
                    name: 'feedback',
                    component: () => import(/* webpackChunkName: "feedback" */ './views/law-firm/Feedback.vue'),
                    meta: {
                        title: 'Feedback'
                    }
                },
            ]
        },
        {
            path: '/holiday',
            name: 'holiday',
            component: () => import(/* webpackChunkName: "holiday" */ './views/holiday/Index.vue'),
            meta: {
                title: 'Urlaub'
            },
            beforeEnter: checkAuthentication,
            children: [
                {
                    path: 'request',
                    name: 'holiday-requester',
                    component: () => import(/* webpackChunkName: "holiday-requester" */ './views/holiday/Requester.vue'),
                    meta: {
                        title: 'Urlaub beantragen'
                    }
                },
                {
                    path: 'overview',
                    name: 'holiday-overview',
                    component: () => import(/* webpackChunkName: "holiday-overview" */ './views/holiday/Overview.vue'),
                    meta: {
                        title: 'Urlaubsübersicht'
                    }
                },
                {
                    path: 'calendar',
                    name: 'holiday-calendar',
                    component: () => import(/* webpackChunkName: "holiday-overview" */ './views/holiday/CalendarView.vue'),
                    meta: {
                        title: 'Urlaubskalender'
                    }
                },
                {
                    path: 'release',
                    name: 'holiday-releaser',
                    component: () => import(/* webpackChunkName: "holiday-releaser" */ './views/holiday/ReleasableRequests.vue'),
                    meta: {
                        title: 'Urlaubsanträge verwalten'
                    }
                },
                {
                    path: 'public-holidays',
                    name: 'public-holidays',
                    component: () => import(/* webpackChunkName: "public-holidays" */ './views/holiday/PublicHolidays.vue'),
                    meta: {
                        title: 'Feiertage verwalten'
                    }
                },
                {
                    path: 'employee-overview',
                    name: 'employee-overview',
                    component: () => import(/* webpackChunkName: "employee-overview" */ './views/holiday/EmployeeOverview.vue'),
                    meta: {
                        title: 'Mitarbeiterübersicht'
                    }
                },
                {
                    path: 'holiday-credits',
                    name: 'holiday-credits',
                    component: () => import(/* webpackChunkName: "holiday-credits" */ './views/holiday/HolidayCredits.vue'),
                    meta: {
                        title: 'Gutschriften'
                    }
                }
            ]
        },
        {
            path: '*',
            name: 'page-not-found',
            component: () => import(/* webpackChungName: "page-not-found" */ './views/PageNotFound.vue'),
            meta: {
                title: 'Seite nicht gefunden'
            }
        }
    ]
});

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) =>
{
    //TODO prüfung ob route zulässig?!

    // This goes through the matched routes from last to first, finding the closest route with a title.
    // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
    let nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

    // If a route with a title was found, set the document (page) title to that value.
    if (nearestWithTitle)
        document.title = nearestWithTitle.meta.title;
    else
        document.title = 'RATIS Mitarbeiterportal';  //TODO: constant? or global config?

    next();
});

export default router;
